// Design tokens copied 1:1 from the approved mockup (docs/design/waw_dashboard_mockup.html
// :root block) so the dashboard feature matches it exactly, independent of the portal's
// generic StyleConstants (which predate this feature and use a different palette).
const DashboardTheme = {
  navy900: '#0f2038',
  navy800: '#17304f',
  navy700: '#284a72',
  navy500: '#4a6a94',
  navy100: '#e7edf5',
  amber500: '#f2a621',
  amber600: '#d98f0f',
  amber100: '#fdf1dc',
  teal500: '#2f8f8a',
  green600: '#2c9a56',
  green100: '#e2f5e8',
  orange500: '#ef8d3a',
  red500: '#dd4b39',
  gray50: '#f6f7fa',
  gray100: '#eef0f4',
  gray200: '#e2e5eb',
  gray300: '#cfd4dd',
  gray500: '#8993a4',
  gray700: '#4b5563',
  white: '#ffffff',
  radius: 14,
  shadow: '0 1px 2px rgba(15,32,56,.04), 0 8px 24px -12px rgba(15,32,56,.12)',
  headerFontFamily: "'Sora', sans-serif",
  bodyFontFamily: "'Inter', sans-serif",
  monoFontFamily: "'IBM Plex Mono', monospace",
};

export default DashboardTheme;
